export const addressSchema = (yup) => {
  return {
    url: yup.string(),
    name: yup.string().required("required"),
  };
};

export const addressInitial = {
  url: "",
  name: "",
};
